<template>
  <div class="form-group theme-login-form-group theme-form-group">
    <label
      :for="`input-field-${_uid}`"
      class="theme-form-label">{{ label }}<template v-if="required">*</template></label>
    <input
      v-if="!mask"
      :id="`input-field-${_uid}`"
      :value="field"
      v-validate="required ? validate : ''"
      :type="type"
      :name="name"
      :class="{ 'alert-danger': submitted && errors.has(name) }"
      :disabled="disabled"
      :readonly="readonly"
      @input="$emit('update:field', $event.target.value)"
      class="form-control" />
    <the-mask
      v-else
      :id="`input-field-${_uid}`"
      v-model="modelField"
      v-validate="required ? validate : ''"
      :type="type"
      :name="name"
      :class="{ 'alert-danger': submitted && errors.has(name) }"
      :mask="mask"
      class="form-control"
      :onpaste="onpaste"
      :ondrop="ondrop"
      :maxlength="maxlength"
      :readonly="readonly" />
      <!--  -->
    <span
      v-if="submitted && errors.has(name)"
      class="theme-form-error-message">{{ errors.first(name) }}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  inject: [ '$validator' ],
  props: [
    'label',
    'required',
    'type',
    'name',
    'validate',
    'submitted',
    'field',
    'mask',
    'onpaste',
    'ondrop',
    'disabled',
    'maxlength',
    'readonly'
  ],
  data () {
    return {
      modelField: null
    }
  },
  watch: {
    modelField (data) {
      this.$emit('update:field', data)
    },
    field (data) {
      this.modelField = data
    }
  }
}
</script>
